
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
  <path
    fill="currentColor"
    d="M421.831111 426.666667h-284.444444V142.222222h284.444444z m56.888889-341.333334h-398.222222v398.222223h398.222222zM876.942222 881.777778h-284.444444V597.333333h284.444444z m56.888889-341.333334h-398.222222v398.222223h398.222222zM507.164444 341.333333h170.666667v170.666667h-170.666667zM336.497778 512h170.666666v170.666667h-170.666666z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'SendBack',
    }) as DefineComponent
    </script>
    